export default __webpack_public_path__ + "static/media/session-time.3b0f6994.svg";